import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { DialogMessage, HistoryItemResponse } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { PostType } from './iframe-communication/botapi-manager.service';
import { KeyValAdminService } from './key-val-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';

@Injectable({
  providedIn: 'root'
})
export class MessageManagerAdminService {
  public onBotToUser: EventEmitter<string> = new EventEmitter<string>();
  public onUserToBot: EventEmitter<string> = new EventEmitter<string>();
  public userMessageEmitter: EventEmitter<string> = new EventEmitter<string>();
  public runCompleteEmitter: EventEmitter<string> = new EventEmitter<string>();
  public runRequestEmitter: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    private keyvalService: KeyValAdminService,
    private botId: BotidService,
    private http: HttpClient
  ) {

  }

  public prompt(text: string) {
    text = "" + text;
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.prompt", { text });


    this.runRequestEmitter.emit(text);
  }

  public userMessage(text: string) {
    text = "" + text;
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.userMessage", { text });
    this.userMessageEmitter.emit(text);
  }

  public async botBypass(text: string) {
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.botBypass", { text });
    const backendPayload: DialogMessage = { content: [{ text, type: "text" }], role: 'assistant', bypass: true };
    const res = await this._addMessagesToThread([backendPayload]);
    if (res[0] != null) {
      window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.botBypassComplete", { text: res[0] });
    }
    return res;
  }

  public async userBypass(text: string) {
    text = "" + text;

    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.userBypass", { text });

    const backendPayload: DialogMessage = { content: [{ text, type: "text" }], role: 'user', bypass: true };
    const res = await this._addMessagesToThread([backendPayload]);
    void window.RAGAI.BOTAPI.postMessage(PostType.userBypassComplete, [res]);
    if (res[0] != null) {
      window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.userBypassComplete", { text: res[0] });
      return res[0];
    }
    throw new Error("Failed to add message");
  }

  // NOTICE: SYSTEMPROMPT MSG HOLT DER SERVER SICH SERVERSEITIG
  // WENN OVERWRITE MIT LEER PROMPT GESETZT
  // TODO:  wir bräuchten einen KEYVAL DELETE um z.b. hier den systemprompt einfach zu löschen
  public async overwriteSystemPrompt(prompt: string) {
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.overwriteSystemPrompt", { prompt });
    await this.keyvalService.set("systemprompt", prompt, "messagemanager");
  }


  public async overwriteWebsearchEnabled(enabled: boolean) {
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.overwriteWebsearchEnabled", { prompt });
    await this.keyvalService.set("websearchenabled", enabled, "messagemanager");
  }

  public async _addMessagesToThread(messages: DialogMessage[]) {
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG._addMessagesToThread", messages);
    const botId = this.botId.getBotId();
    const res = await firstValueFrom(this.http.post<HistoryItemResponse[]>('/api/toolbox/membot/user/createmessagesinthread/' + botId, { messages }));

    return res;
  }



  public async botMessage(text: string) {
    text = "" + text;
    window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.botMessage", { text });

    if (window.location.pathname.includes("audio") || window.location.pathname.includes("avatar")) {
      await window.RAGAI.AUDIO.botSay(text, undefined);
    }
    const res = await this._addMessagesToThread([{
      role: 'assistant',
      content: [{ text, type: "text" }]
    }]);
    void window.RAGAI.BOTAPI.postMessage(PostType.botMessageComplete, text);
    return res[0];
  }

  /**
   * Fügt eine normale (nicht-bypass) Nutzer-Nachricht direkt in den Thread ein,
   * ohne dafür eine reguläre KI-Chat-Anfrage auszulösen (kein Aufruf von `prompt()`
   * oder `userMessage()`, welche den normalen Sende-Flow erneut anstoßen würden).
   * Wird z.B. vom Freitext-Quiz genutzt, um die vom Nutzer eingegebene Antwort
   * sichtbar im Verlauf zu protokollieren.
   */
  public async userMessageDirect(text: string) {
    text = "" + text;
    const res = await this._addMessagesToThread([{
      role: 'user',
      content: [{ text, type: "text" }]
    }]);
    return res[0];
  }

}
